import React, {useContext, useState} from 'react';
import {PortalSelect, PortalSelectOption} from '../PortalSelect';
import {BASIC_ELEMENT_SCHEMA} from '../layout/Group';
import {ModelContext} from '../metadata/ModelSource';
import { ApplicationActionsContext } from '../data/ApplicationDataSource';
import Select, {Props} from 'react-select';
import { FormContext } from '../metadata/MDForm';
import { formatMoneyAmountNoDecimal } from '../../utils/formatUtils';
import {Attribute, AttributeCondition} from "../metadata/api/attribute";
import { getOptionsForAttr } from './coderefs';

const mapAndFormat = (array) => {
  return array.map(
    (value) => `$${formatMoneyAmountNoDecimal(parseInt(value))}`
  );
};

const formatPrevious = (previousValue) => {
  const prevArray = previousValue.split('/');
  const formatted = mapAndFormat(prevArray);
  return `${formatMoneyAmountNoDecimal(formatted)}`;
};

export function UIMBILimitSelector({attr, additionalOptions, dataType, mutuallyExclusive, ...props}) {

  let applicationModel = useContext(ModelContext);
  let line = applicationModel.getValue(`lines{lineCd:CollectorVehicle}`);
  
  const formContext = useContext(FormContext);
  let attribute = formContext.metadata[attr];
  
  let allOptions = getOptionsForAttr(attribute).list;
  let limitOptions = [];

  let disabled = false;
  if(mutuallyExclusive == "true"){
    disabled = true;
    if(line.umbiLimit == "0" && !props.disabledWhenZero ){
      disabled = false;
    }
  }

  let bi = line.biLimit;
  if(bi.includes("/")){
    let splitBi = bi.split("/");
    for(let i = 0; i < allOptions.length; i++){
      const optionValueArray = allOptions[i].value.split('/') ;
      if( allOptions[i].name.includes("/") || (mutuallyExclusive == "true" && allOptions[i].name == "No Coverage")) {
        let maxBI1 = parseInt(splitBi[0]);
        let maxBI2 = parseInt(splitBi[1]);
        if( props.doubledBIApplicable ) {
          maxBI1 = maxBI1 * 2;
          maxBI2 = maxBI2 * 2;
        }
        if( parseInt(optionValueArray[0]) < maxBI1 ) {
          limitOptions.push(allOptions[i]);
        }
        else if( parseInt(optionValueArray[0]) == maxBI1 ) {
          if( parseInt(optionValueArray[1]) <= maxBI2 ) {
            limitOptions.push(allOptions[i]);
          }
        }
      }
    }
  }
  else{
    if(mutuallyExclusive != "true" && line.uimbiLimit.includes("/")){
      line.uimbiLimit = bi;
      props.value = bi;
    }
    let index = 0;
    for(index = 0; index < allOptions.length; index++){
      var opt = allOptions[index];
      let maxBI = parseInt(bi);
      if( props.doubledBIApplicable ) {
        maxBI = maxBI * 2;
      }
      if(opt.value.includes("/") == false && parseInt(allOptions[index].value) <= maxBI){
        limitOptions.push(allOptions[index]);
      }
    }
  }

  if (additionalOptions && additionalOptions.length) {
    limitOptions = [...limitOptions, ...additionalOptions];
  }

  if(dataType && dataType === 'SelectUpdate'){
    let selected = null;
    let children = limitOptions.map(({value, name}) => <PortalSelectOption value={value}>
        {name}
      </PortalSelectOption>);
    const options = React.Children.map(children, el => {
        if (!el.props) {
          return null;
        }
        const obj = {
          label: el.props.children,
          value: el.props.value
        };
        if (el.props.value === props.value) {
          selected = obj;
        }
        return obj;
    });
    
    const actions = useContext(ApplicationActionsContext);
    const { setValueByAttr, getValueByAttr } = formContext;
    const previousValue = selected;
    const [selectedValue, setSelectedValue] = useState(previousValue);
    
    const handleChange = (selected) => {
      setValueByAttr(attr, selected.value);
      setSelectedValue(selected);

      if(mutuallyExclusive == "true" && selected.value != "0"){
        line.umbiLimit = "0"
      }

      actions.saveApplication();
    };

    return <Select
        {...props}
        isDisabled={disabled}
        aria-label="Select"
        styles={customStylesUpdater}
        title="Select"
        openMenuOnFocus
        placeholder={null}
        options={options}
        value={selected}
        onChange={handleChange}
        components={{
          IndicatorSeparator: () => null,
        }}
        theme={(theme) => ({
          ...theme,
          borderRadius: 4,
          zIndex: 3,
          colors: {
            ...theme.colors,
            primary25: 'rgb(0, 115, 157, 0.1)',
            primary: 'rgba(0, 115, 157, 0.5)',
            neutral30: 'rgba(0, 115, 157, 0.5)',
          },
        })}
      />
  }
  return <PortalSelect {...props}>
    {
      options.map(({value, name}) => <PortalSelectOption value={value}>
        {name}
      </PortalSelectOption>)
    }
  </PortalSelect>;
}

const customStylesUpdater = {
  control: (base) => ({
    ...base,
    width: '158px',
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  menu: (styles) => ({ ...styles, zIndex: 999 }),
};

UIMBILimitSelector.schema = BASIC_ELEMENT_SCHEMA;